import React from "react";
import { Box, Button } from "@mui/material";

const UploadFiles = ({ title, handleAttachedFiles, imgSrc, acceptType }) => {
    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <img
                    src={imgSrc}
                    loading="lazy"
                    alt="image"
                    style={{
                        height: "10rem",
                        objectFit: "cover",
                    }}
                />
            </Box>
            <Button
                variant="outlined"
                component="label"
                sx={{
                    marginRight: "auto",
                    marginLeft: "auto",
                    width: "16rem",
                    mb: 2,
                }}
            >
                {title}
                <input
                    type="file"
                    multiple
                    hidden
                    // accept=".jpg,.jpeg,.png,.xlsx,.xls,.csv,.txt,.docx,.pdf"
                    accept={acceptType}
                    onChange={handleAttachedFiles}
                />
            </Button>
        </>
    );
};

export default UploadFiles;
